export const ShortDateFormat = 'DD-MM-YYYY'
export const ShortDateWithTimeFormat = 'DD-MM-YYYY H:mm:ss'
export const ShortDateWithHoursAndMinutesFormat = 'DD-MM-YYYY H:mm'
export const ShortDateWithHoursAndMinutes12HFormat = 'DD-MM-YYYY h:mm A'
export const FullDateFormat = 'Do MMMM YYYY'
export const FullDateWithTimeFormat = 'Do MMMM YYYY hh:mm:ss A'
export const shortDateWithoutTimeFormat = 'YYYY-MM-DD'
export const FullDateWitMilliSeconds = 'YYYY-MM-DD HH:mm:ss.SSS'
export const FulldateWithTMilliSeconds = 'YYYY-MM-DDTHH:mm:ss.SSS'
export const FullTimeOnly = 'HH:mm:ss'
export const DateYearWithTime = 'YYYY-MM-DD HH:mm'
export const shortTime = 'HH:mm'
export const shorterTime = 'H:mm'
export const DayMonthDateTimeFormat = 'dddd, MMMM DD, HH:mm'
export const DayMOnthDateFormat = 'ddd MMMM DD'
export const DayMOnMonthOnYear = 'DD MMM YYYY'
export const clockFormat = 'HH:mm:ss'
export const fullMonthFormat = 'MMMM'
export const fullDayFormat = 'dddd'
export const dayOnlyFormat = 'DD'
export const fullTimeFormat = 'HH:mm:ss.SSS'
export const H12HourTimeFormat = 'h A'
export const fullYear = 'YYYY'
export const shortMonthFullYear = 'MM/YYYY'
export const shortDateWithTime = 'YY-MM-DD HH:mm'
export const fullDateWithWeekdayFormat = 'dddd, MMMM Do YYYY'
export const intervalDateFormat = 'DD/MM/YYYY'
export const longMonthAndYear = 'MMMM YYYY'

export const EXPORT_CSV_TIME_FORMAT = 'MM/DD/YYYY HH:mm:ss'
export const TimeZone = '2'